import {
  ReferralUrlByOrderIdDocument,
  ReferralUrlByWaitlistUserIdDocument,
} from "~graphql/typed-document-nodes";
import { useQuery } from "~hooks/useQuery";
import { getUrl } from "~lib";

export const useReferralLink = ({
  eventId,
  waitlistUserId,
  organizationSlug,
  orderId,
}: {
  eventId?: string;
  waitlistUserId?: string;
  orderId?: string;
  organizationSlug: string;
}) => {
  const { data: waitlistReferralUrl } = useQuery(
    eventId && waitlistUserId && ReferralUrlByWaitlistUserIdDocument,
    {
      eventId,
      waitlistUserId,
    }
  );

  const { data: referralUrl } = useQuery(
    orderId && ReferralUrlByOrderIdDocument,
    {
      orderId,
    }
  );

  const link =
    waitlistReferralUrl?.referralUrlByWaitlistUserId ??
    referralUrl?.referralUrlByOrderId ??
    `${getUrl(organizationSlug, true)}/events/${eventId}/waitlist`;

  return link;
};
